export default __webpack_public_path__ + "static/media/1717.87b6ce69.png";